import {useEffect, useRef} from "react";

interface IScrollObserverCallbackParams {
    scrollY: number;
}

type IScrollObserverCallback = (params: IScrollObserverCallbackParams) => void;

export const useScrollObserver = (callback: IScrollObserverCallback, deps: readonly unknown[], isActive = true) => {
    const isTicking = useRef(false);

    useEffect(() => {
        if (!isActive) {
            return;
        }

        const scrollObserverFn = () => {
            if (!isTicking.current) {
                window.requestAnimationFrame(() => {
                    const scrollY = window.scrollY;
                    callback({scrollY});

                    isTicking.current = false;
                });
            }

            isTicking.current = true;
        };

        window.addEventListener("scroll", scrollObserverFn, false);

        return () => {
            window.removeEventListener("scroll", scrollObserverFn, false);
        };
    }, [...deps, isActive]);
};
import {useEffect, useRef} from "react";

interface IScrollObserverCallbackParams {
    scrollY: number;
}

type IScrollObserverCallback = (params: IScrollObserverCallbackParams) => void;

export const useScrollObserver = (callback: IScrollObserverCallback, deps: readonly unknown[], isActive = true) => {
    const isTicking = useRef(false);

    useEffect(() => {
        if (!isActive) {
            return;
        }

        const scrollObserverFn = () => {
            if (!isTicking.current) {
                window.requestAnimationFrame(() => {
                    const scrollY = window.scrollY;
                    callback({scrollY});

                    isTicking.current = false;
                });
            }

            isTicking.current = true;
        };

        window.addEventListener("scroll", scrollObserverFn, false);

        return () => {
            window.removeEventListener("scroll", scrollObserverFn, false);
        };
    }, [...deps, isActive]);
};
